import { styled } from "../theme";
export const DropdownMenuSeparator = styled.div `
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.color.gray10};
`;
